<template>
  <div class="px-4 pt-2 pb-3">
    <v-btn-toggle
    :value="value"
    mandatory
    dense
    rounded
    @change="modeChosen">
      <v-btn
      v-for="mode in TagFilterMode.enums"
      :key="mode.value"
      :value="mode.value"
      small
      :color="value === mode.value ? 'primary' : undefined"
      :class="value === mode.value ? 'white--text' : 'grey--text text--darken-1'">
        <v-tooltip bottom color="primary">
          <template #activator="{ on }">
            <span v-on="on" class="d-flex align-center lh-0">
              <v-icon small left>{{ mode.details.icon }}</v-icon>{{ mode.name }}
            </span>
          </template>
          <span class="subtitle-1 white--text">{{ $t(mode.details.description) }}</span>
        </v-tooltip>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TagFilterMode } from '@/utils/Enumerations.js'
import { SETTING_TYPES, SETTING_KEYS } from '@/utils/UserSettings.js'

export default {
  name: 'TagFilterModeToggle',

  props: {
    value: { type: Number, required: true },
    userSetting: { type: String, default: undefined }
  },

  data: () => ({
    TagFilterMode
  }),

  computed: {
    ...mapGetters('user-settings', ['mutatedUserSettings'])
  },

  methods: {
    ...mapActions('user-settings', ['updateUserSettings']),
    ...mapMutations('user-settings', ['mutateUserSetting']),

    modeChosen (mode) {
      this.$emit('input', mode)
      if (!this.userSetting) return

      const tagFilterModes = this.mutatedUserSettings[SETTING_TYPES.AUTOCOMPLETE][SETTING_KEYS.ACCOUNT_AUTOCOMPLETE_TAG_FILTER_MODES]
      this.mutateUserSetting({
        type: SETTING_TYPES.AUTOCOMPLETE,
        key: SETTING_KEYS.ACCOUNT_AUTOCOMPLETE_TAG_FILTER_MODES,
        value: { ...tagFilterModes, [this.userSetting]: mode }
      })
      this.updateUserSettings(this.mutatedUserSettings)
    }
  }
}
</script>
